document.addEventListener("DOMContentLoaded", (event) => {

    const carousel = document.querySelectorAll('.sc-carousel');

    if (carousel) {
        carousel.forEach(carousel_block => {

            const list = carousel_block.querySelector('.sc-carousel__list');
            const next = carousel_block.querySelector('.sc-carousel__next-btn') || null;
            const prev = carousel_block.querySelector('.sc-carousel__prev-btn') || null;
            const nav_container = carousel_block.querySelector('.sc-carousel__nav') || null;

            const swiper = new Swiper(list, {
                loop: true,
                loopPreventsSliding: true,
                autoplay: {
                    delay: 7500,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev,
                },
                on: {
                    init: function () { toggleCustomNavigation(this, nav_container); },
                    resize: function () { toggleCustomNavigation(this, nav_container); },
                },
                slidesPerView: 1,
                spaceBetween: 34,
                autoHeight: true,
                breakpoints: {
                    769: {
                        slidesPerView: 2,
                        spaceBetween: 34,
                    },
                    1200: {
                        slidesPerView: 2,
                        spaceBetween: 34,
                    }
                }
            });

        });

        function toggleCustomNavigation(swiperInstance, nav_container) {
            if (swiperInstance.params.navigation && nav_container) {
                if (swiperInstance.slides.length <= swiperInstance.params.slidesPerView) {
                    nav_container.style.display = 'none';
                } else {
                    nav_container.style.display = 'flex';
                }
            }
        }
    }

});
